<script>
    export let data;

    import {Button, Modal, Tile, DatePicker, DatePickerInput} from "carbon-components-svelte";
    import NextOutline20 from "carbon-icons-svelte/lib/NextOutline20";
    import { updateTask } from "../store";
    import EnumStatus from "../services/taskstatus";

	const theme = {
		calendar: {
			width: '800px',
			shadow: '0px 0px 5px rgba(0, 0, 0, 0.25)'
		}
	};

    const toTimestamp = (strDate) => {  
        const dt = Date.parse(strDate);  
        return dt / 1000;  
    }  

    function updateTaskDefered() {
        //Set Delegated
        data.status = EnumStatus.SCHEDULED;
        //Select Who
        //Select followup date
        //const date = new proto.google.protobuf.Timestamp();
        const date = new Date(duedate);
        data.nextaction = date;

        updateTask(data)
        open = false;
    }


    let duedate = new Date();
    duedate.setDate(duedate.getDate() + 7);

    let open = false;
    let newdelegateto;
    //let taskid = data.id;
</script>

<!-- Button trigger modal -->
<Button kind="ghost"  iconDescription="Defer" on:click={() => (open = true)} icon={NextOutline20}
></Button
>

<!-- Modal -->
<Modal
bind:open
modalHeading="Schedule Task"
primaryButtonText="Schedule"
secondaryButtonText="Cancel"
on:click:button--secondary={() => (open = false)}
on:open
on:close
on:submit={updateTaskDefered}
size:lg
>
<!-- <InlineCalendar on:submit {theme} bind:selected={duedate} /> -->
<div class="min-width: 16rem">
<DatePicker dateFormat="Y-M-d" datePickerType="single" bind:value={duedate} on:change flatpickrProps={{ static: true }}>
    <DatePickerInput labelText="Defer Until Date" placeholder="yyyy-MM-dd" />
  </DatePicker>
</div>
</Modal>

<style>
  .btx--tile {
    min-height: 18rem;
  }
  </style>